import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import useRedirectRoute, { isSafeRedirect } from './useRedirectRoute';

export default function useRememberLastUserPath() {
  const location = useLocation();
  const { setRedirect } = useRedirectRoute();

  const rememberLastUserPath = useCallback(() => {
    const currentPath = location.pathname + location.search;
    if (isSafeRedirect(currentPath)) {
      setRedirect(currentPath);
    }
  }, [location, setRedirect]);

  return { rememberLastUserPath };
}
